import { CircularProgress } from '@packages/shared/src/components/CircularProgress/CircularProgress';

import type { JSX } from 'react';

/**
 * This component displays Loader on Service Layer
 * @returns JSX.Element to be placed in Service Layer
 */
export const ServiceLayerLoader = (): JSX.Element => (
  <div className="flex size-full items-center justify-center">
    <CircularProgress size="m" />
  </div>
);
